import {
  ESplitDate,
  originalSubDirectAmount,
  switch1SubDirectAmount,
  switch2SubDirectAmount,
  switch3SubDirectAmount,
  switch4SubDirectAmount,
} from '~/constants/prices';
import type { ESubIds } from '~/types/GioNode';

export const getDirectAmount = (sub: number, purchaseDate: string) => {
  if (new Date(purchaseDate) < new Date(ESplitDate.SWITCH1)) {
    return originalSubDirectAmount[sub as ESubIds];
  } else if (
    new Date(purchaseDate) >= new Date(ESplitDate.SWITCH1) &&
    new Date(purchaseDate) < new Date(ESplitDate.SWITCH2)
  ) {
    return switch1SubDirectAmount[sub as ESubIds];
  } else if (
    new Date(purchaseDate) >= new Date(ESplitDate.SWITCH2) &&
    new Date(purchaseDate) < new Date(ESplitDate.SWITCH3)
  ) {
    return switch2SubDirectAmount[sub as ESubIds];
  } else if (
    new Date(purchaseDate) >= new Date(ESplitDate.SWITCH3) &&
    new Date(purchaseDate) < new Date(ESplitDate.SWITCH4)
  ) {
    return switch3SubDirectAmount[sub as ESubIds];
  } else if (new Date(purchaseDate) >= new Date(ESplitDate.SWITCH4)) {
    return switch4SubDirectAmount[sub as ESubIds];
  }

  return 0;
};
